import React, { useContext, useEffect, useState } from 'react';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import { useDispatch } from 'react-redux';
import { DisappearedDoctorApi } from '../../redux/doctors/doctorApiCalls';
import { ShowDoctorContext } from './types';
import { Timeout } from '../../functions/functions';
import { InputElement } from '../../HtmlComponents/InputElement';
import { InputRadio } from '../../HtmlComponents/InputRadio';

type props = {
  modal: boolean,
  toggle: any
}

const DisappearDoctorModal:React.FC<props> = ({ modal, toggle }) => {
  const [loading, setLoading] = useState(false)
  const dispatch: any = useDispatch()

  const { setShowSuccessMsg, selectedDoctor } = useContext(ShowDoctorContext)

  const [disappeared, setDisappeared] = useState(false)
  const [note, setNote] = useState("")

  useEffect(() => {
    setDisappeared(selectedDoctor.status?.disappeared)
    setNote(selectedDoctor.status?.note)
  }, [selectedDoctor])


  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response: any = await dispatch(DisappearedDoctorApi(selectedDoctor._id, {
        disappeared, note
      }))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout) 
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <div>
                      <p className='font-bold md:text-2xl'>Disparu(e)</p>
                      <InputRadio labelName='Oui' id="Oui" boolean={true} checked={disappeared === true }  booleanValue={true} setValue={setDisappeared}/>
                      <InputRadio labelName='Non' id="Non" boolean={true} checked={disappeared === false } booleanValue={false} setValue={setDisappeared}/>
                    </div>
                    <InputElement name='note' value={note} setValue={setNote}/>
                    <ButtonsForm typeBtn='Enregistrer' loading={loading} toggle={toggle}/>
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default DisappearDoctorModal
